// Shipping Fee Form Handler
// Handles region, state, and city fields for shipping fee form
// - If region is East Malaysia, get states from malaysia_areas.rb (states of East Malaysia)
// - If region is West Malaysia, get states from malaysia_areas.rb (states of West Malaysia)
// - If region is Singapore, state should be disabled
// - If region is East Malaysia or West Malaysia, city should be select (from malaysia_areas.rb)
// - If region is Singapore, city should be text input

$(document).ready(function() {
  var regionSelect = $('.shipping-fee-region-select, #shipping_fee_region');
  var stateSelect = $('.shipping-fee-state-select, #shipping_fee_state');
  var citySelect = $('.shipping-fee-city-select, #shipping_fee_city_select');
  var cityText = $('.shipping-fee-city-text, #shipping_fee_city_text');
  var citySelectWrapper = $('#select-city');
  var cityTextWrapper = $('#text-city');
  var getStatesUrl = '/api/v3/get_states';
  var getCitiesUrl = '/api/v3/get_cities';

  // Initialize on page load
  initializeStateField();
  initializeCityField();

  // Handle region change
  regionSelect.on('change', function() {
    var selectedRegion = $(this).val();
    updateStateOptions(selectedRegion);
    updateCityField(selectedRegion);
  });

  // Handle state change (for loading cities)
  stateSelect.on('change', function() {
    var selectedRegion = regionSelect.val();
    var selectedState = $(this).val();

    if (selectedRegion && selectedRegion !== 'Singapore' && selectedState) {
      loadCitiesForState(selectedState);
    } else {
      clearCitySelect();
    }
  });

  function initializeStateField() {
    var selectedRegion = regionSelect.val();
    if (selectedRegion) {
      updateStateOptions(selectedRegion);
    } else {
      // No region selected, disable state
      disableStateField();
    }
  }

  function updateStateOptions(region) {
    if (!region || region === '') {
      disableStateField();
      return;
    }

    // ShippingFee enum uses "East Malaysia", "West Malaysia", "Singapore" as keys
    // So region value is already in the correct format
    var regionName = region;

    if (region === 'Singapore' || region.toLowerCase() === 'singapore') {
      // Singapore: disable state field
      disableStateField();
      stateSelect.val('').trigger('change');
    } else {
      // East Malaysia or West Malaysia: load states from API
      loadStatesForRegion(regionName);
    }
  }

  function loadStatesForRegion(regionName) {
    // Preserve the currently selected value before clearing
    var currentSelectedState = stateSelect.val();

    // Show loading state
    stateSelect.prop('disabled', true);
    stateSelect.html('<option value="">Loading...</option>');

    $.ajax({
      type: 'GET',
      url: getStatesUrl,
      data: { region: regionName },
      dataType: 'json',
      success: function(response) {
        if (response.states && response.states.length > 0) {
          // Clear existing options
          stateSelect.html('<option value="">Select State</option>');

          // Add state options
          $.each(response.states, function(index, state) {
            var isSelected = (state === currentSelectedState);
            stateSelect.append($('<option>', {
              value: state,
              text: state,
              selected: isSelected
            }));
          });

          // Restore the selected value if it exists in the new options
          if (currentSelectedState && response.states.includes(currentSelectedState)) {
            stateSelect.val(currentSelectedState);
          }

          // Enable state field
          stateSelect.prop('disabled', false);

          // If we have a selected state (e.g. on edit page load), load its cities
          var finalSelectedState = stateSelect.val();
          var currentRegion = regionSelect.val();
          if (currentRegion && currentRegion !== 'Singapore' && finalSelectedState) {
            loadCitiesForState(finalSelectedState);
          }
        } else {
          // No states found
          stateSelect.html('<option value="">No states available</option>');
          stateSelect.prop('disabled', true);
        }
      },
      error: function(xhr, status, error) {
        console.error('Error loading states:', error);
        stateSelect.html('<option value="">Error loading states</option>');
        stateSelect.prop('disabled', true);
      }
    });
  }

  function disableStateField() {
    stateSelect.prop('disabled', true);
    stateSelect.html('<option value="">Select State</option>');
  }

  function initializeCityField() {
    var selectedRegion = regionSelect.val();
    if (selectedRegion) {
      updateCityField(selectedRegion);

      // If state is already selected, load cities
      var selectedState = stateSelect.val();
      if (selectedState && selectedRegion !== 'Singapore') {
        loadCitiesForState(selectedState);
      }
    } else {
      // No region selected, show text input by default
      showCityTextInput();
    }
  }

  function updateCityField(region) {
    if (!region || region === '') {
      showCityTextInput();
      return;
    }

    if (region === 'Singapore' || region.toLowerCase() === 'singapore') {
      // Singapore: show text input
      showCityTextInput();
    } else {
      // East Malaysia or West Malaysia: show select dropdown
      showCitySelect();
      // Load cities if state is already selected
      var selectedState = stateSelect.val();
      if (selectedState) {
        loadCitiesForState(selectedState);
      } else {
        clearCitySelect();
      }
    }
  }

  function showCitySelect() {
    // Show select, hide text input
    citySelectWrapper.removeClass('d-none');
    cityTextWrapper.addClass('d-none');

    // Preserve original name attributes
    var selectName = citySelect.data('original-name') || citySelect.attr('name');
    var textName = cityText.data('original-name') || cityText.attr('name');

    if (selectName) {
      citySelect.data('original-name', selectName);
    }
    if (textName) {
      cityText.data('original-name', textName);
    }

    // Use the same name for both (they should both be 'shipping_fee[city]' from Rails)
    var cityFieldName = selectName || textName || 'shipping_fee[city]';

    // Set name attribute on select, remove from text
    citySelect.attr('name', cityFieldName);
    cityText.removeAttr('name');

    // Enable select, disable text
    citySelect.prop('disabled', false);
    cityText.prop('disabled', true);
  }

  function showCityTextInput() {
    // Show text input, hide select
    citySelectWrapper.addClass('d-none');
    cityTextWrapper.removeClass('d-none');

    // Preserve original name attributes
    var selectName = citySelect.data('original-name') || citySelect.attr('name');
    var textName = cityText.data('original-name') || cityText.attr('name');

    if (selectName) {
      citySelect.data('original-name', selectName);
    }
    if (textName) {
      cityText.data('original-name', textName);
    }

    // Use the same name for both (they should both be 'shipping_fee[city]' from Rails)
    var cityFieldName = textName || selectName || 'shipping_fee[city]';

    // Set name attribute on text, remove from select
    cityText.attr('name', cityFieldName);
    citySelect.removeAttr('name');

    // Enable text, disable select
    cityText.prop('disabled', false);
    citySelect.prop('disabled', true);
  }

  function loadCitiesForState(stateName) {
    if (!stateName) {
      clearCitySelect();
      return;
    }

    // Preserve the currently selected value before clearing.
    // Fall back to the original city from data-current-city (set by Rails) if needed.
    var currentSelectedCity = citySelect.val() || citySelect.data('current-city');

    // Show loading state
    citySelect.prop('disabled', true);
    citySelect.html('<option value="">Loading...</option>');

    $.ajax({
      type: 'GET',
      url: getCitiesUrl,
      data: { state_name: stateName },
      dataType: 'json',
      success: function(response) {
        if (response.cities && response.cities.length > 0) {
          // Clear existing options
          citySelect.html('<option value="">Select City</option>');

          // Add city options
          $.each(response.cities, function(index, city) {
            var isSelected = (city === currentSelectedCity);
            citySelect.append($('<option>', {
              value: city,
              text: city,
              selected: isSelected
            }));
          });

          // Restore the selected value if it exists in the new options
          if (currentSelectedCity && response.cities.includes(currentSelectedCity)) {
            citySelect.val(currentSelectedCity);
          }

          // Enable city select
          citySelect.prop('disabled', false);
        } else {
          // No cities found
          citySelect.html('<option value="">No cities available</option>');
          citySelect.prop('disabled', true);
        }
      },
      error: function(xhr, status, error) {
        console.error('Error loading cities:', error);
        citySelect.html('<option value="">Error loading cities</option>');
        citySelect.prop('disabled', true);
      }
    });
  }

  function clearCitySelect() {
    citySelect.html('<option value="">Select City</option>');
    citySelect.prop('disabled', true);
  }
});
